var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.754 20.485h5.3c1.201 0 2.61-.754 2.43-2.26-.18-1.505-.996-7.98-1.086-8.482-.09-.502-.366-2.067-2.35-2.067H9.043c-1.348 0-2.756.168-3.004 1.982-.247 1.815-.936 7.435-1.033 8.567-.097 1.133.947 2.26 2.089 2.26h5.659zm-2.75-12.973v-.461c0-.586.578-2.551 2.735-2.551s2.76 1.898 2.76 2.547v.465",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBag;